import React from "react";
import { Link } from "gatsby";
import initIsotope from "common/initIsotope";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const techList = [
  {
    name: "Magento",
    dataFilter: ".magento",
  },
  {
    name: "Shopify",
    dataFilter: ".shopify",
  },
  {
    name: "Wordpress",
    dataFilter: ".wordpress",
  },
  {
    name: "SAAS",
    dataFilter: ".saas",
  },
  {
    name: "Branding",
    dataFilter: ".branding",
  },
  {
    name: "Mobile Apps",
    dataFilter: ".mobile",
  },
  {
    name: "REST/SOAP",
    dataFilter: ".restsoap",
  },
  {
    name: "E-Learning",
    dataFilter: ".elearning",
  },
  {
    name: "Other Commerce",
    dataFilter: ".ecommerce",
  },
];

const WorksStyle2 = ({
  grid,
  hideTitle,
  hideFilter,
  filterPosition,
  projectData,
  propData,
}) => {
  const parts = propData?.path.split("/");
  const lastPart = parts && parts[parts?.length - 2];

  React.useEffect(() => {
    setTimeout(() => {
      initIsotope();
    }, 1000);
  }, []);

  const projectType = (arr) => {
    var str = "";
    if (arr?.length > 0) {
      arr.forEach((val) => {
        str += " " + val;
      });
    }
    return str;
  };

  return (
    <section
      className={`${
        grid ? (grid === 3 ? "three-column" : null) : null
      } portfolio section-padding pb-70 wow fadeInUp`}
    >
      {!hideTitle && (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="sec-head text-center">
                <p className="wow fadeIn sec-eyebrow" data-wow-delay=".5s">
                  Portfolioss
                </p>
                <h2 className="wow color-font sec-title">
                  Our Recent Web Design &amp; <br /> Some Past Projects.
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={"container"}>
        <div className="row">
          {!hideFilter && (
            <div
              className={`filtering ${
                filterPosition === "center"
                  ? "text-center"
                  : filterPosition === "left"
                  ? "text-left"
                  : "text-right"
              } col-12`}
            >
              <div className="filter">
                <span data-filter=".all" className="active">
                  All
                </span>
                {techList &&
                  techList.map((item, i) => (
                    <span key={i} data-filter={item.dataFilter}>
                      {item.name}
                    </span>
                  ))}
              </div>
            </div>
          )}

          <div className="gallery full-width">
            {projectData &&
              projectData
                .slice(0, lastPart === "work" ? projectData.length : 12)
                .map((data, i) => {
                  const featuredImage = getImage(
                    data?.featuredImage?.node?.localFile,
                  );

                  return (
                    <div
                      key={i}
                      className={`${
                        grid === 3
                          ? "col-lg-4 col-md-6"
                          : grid === 2
                          ? "col-md-6"
                          : "col-12"
                      } 
                    ${projectType(
                      data?.projectType,
                    )} items wow fadeInUp work-section-height`}
                      data-wow-delay=".1s"
                    >
                      <div className="item-img bg-laptop">
                        <Link
                          to={`/work/${data?.slug}`}
                          className="imago wow"
                          onClick={() => {
                            checkPaceClass();
                          }}
                        >
                          {featuredImage ? (
                            <GatsbyImage
                              image={featuredImage}
                              alt={
                                data?.imageAlt ||
                                data?.projectName ||
                                "Project image"
                              }
                            />
                          ) : (
                            <img
                              src="/img/portfolio/1.jpg"
                              alt={
                                data?.imageAlt ||
                                data?.projectName ||
                                "Project image"
                              }
                              loading="lazy"
                            />
                          )}
                          <div className="item-img-overlay"></div>
                        </Link>
                      </div>
                      <div className="cont">
                        <Link
                          to={`/work/${data?.slug}`}
                          className="imago wow"
                          onClick={() => {
                            checkPaceClass();
                          }}
                        >
                          <h3 className="project-title">{data?.projectName}</h3>
                        </Link>
                        <div className="color-font project-tech-list">
                          {data &&
                            data.technologiesData &&
                            data.technologiesData.nodes
                              .slice(0, 3)
                              .map((tech, index) => (
                                <Link
                                  key={index}
                                  to={`/technologies/${tech.title.toLowerCase()}`}
                                  onClick={() => {
                                    checkPaceClass();
                                  }}
                                >
                                  <span>
                                    {(index ? ", " : "") + tech.title}
                                  </span>
                                </Link>
                              ))}
                        </div>
                        <p>
                          <small>{data?.shortDescription}</small>
                        </p>
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorksStyle2;
